<div class="sign-in-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div
        class="daxa-form ml-auto mr-auto border-radius bg-white"
        [class.card-borderd-theme]="themeService.isCardBorder()"
        [class.component-dark-theme]="themeService.isDark()"
        [class.rtl-enabled]="themeService.isRTLEnabled()"
        >
        <div class="title text-center">
          <h3>
            Prijava
          </h3>
          <!-- <p class="text-black">
          Još uvijek nemate korisnički račun? <a [routerLink]="['/authentication/sign-up', 'municipality']" class="text-daxa">Registrirajte se kao općina</a>
        </p>     -->
      </div>

      @if (errorMessage) {
        <div class="error text-danger text-center mb-3">
          {{ errorMessage }}
        </div>
      }

      <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label class="main-label d-block lh-1 text-black">
            Adresa e-pošte.
          </label>
          <mat-form-field>
            <mat-label>
              Unesite adresu e-pošte.
            </mat-label>
            <input matInput type="email" id="email" formControlName="email">
          </mat-form-field>
          @if (authForm.get('email')!.hasError('required') && authForm.get('email')!.touched) {
            <div class="error text-danger">
              E-pošta je obavezno polje.
            </div>
          }
          @if (authForm.get('email')!.hasError('email') && authForm.get('email')!.touched) {
            <div class="error text-danger">
              Unesite valjanu adresu e-pošte.
            </div>
          }
        </div>
        <div class="form-group">
          <label class="main-label d-block lh-1 text-black">
            Vaša lozinka
          </label>
          <mat-form-field>
            <mat-label>
              Unesite lozinku
            </mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" id="password" formControlName="password">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <span class="material-symbols-outlined">
                {{hide ? 'visibility_off' : 'visibility'}}
              </span>
            </button>
          </mat-form-field>
          @if (authForm.get('password')!.hasError('required') && authForm.get('password')!.touched) {
            <div class="error text-danger">
              Lozinka je obavezno polje.
            </div>
          }
          @if (authForm.get('password')!.hasError('minlength') && authForm.get('password')!.touched) {
            <div class="error text-danger">
              Lozinka mora imati najmanje 8 znakova.
            </div>
          }
        </div>
        <div class="info d-flex justify-content-between align-items-center">
          <!-- <mat-checkbox>
          Zapamti me
        </mat-checkbox> -->
        <!-- <a routerLink="/authentication/forgot-password" class="d-inline-block text-daxa">
        Zaboravljena lozinka?
      </a> -->
    </div>
    <button mat-button class="btn" type="submit" [disabled]="authForm.invalid">
      Prijava
    </button>
  </form>
</div>
</div>
</div>
</div>